import { Image } from '@chakra-ui/react';
import { Flex, Text, Grid, GridItem } from '@everlywell/ui-kit';
import { GatsbyImage } from 'gatsby-plugin-image';
import React from 'react';
import { ImageType } from 'utils/types';

import SectionContainer from '../components/SectionContainer';
import SectionHeader from '../components/SectionHeader';

export type FeatureSectionProps = {
  title?: string;
  eyebrow?: string;
  cards: {
    image: ImageType | null;
    description: string;
  }[];
};

const FeatureSection = ({ title, eyebrow, cards }: FeatureSectionProps) => (
  <SectionContainer size={['sm', null, null, 'xl']} centerContent>
    <SectionHeader title={title} eyebrow={eyebrow} />
    <Grid columns={[1, 2, 3, 3]} spacing="4" justifyContent="center">
      {cards.map((card, index) => (
        <GridItem key={`description-${index}`}>
          <Flex
            textAlign="center"
            flexDirection="column"
            gap="4"
            marginBottom={['4', null, null, 0]}
          >
            <Image
              as={GatsbyImage}
              image={card?.image?.gatsbyImageData}
              alt={card?.image?.description}
            />
            <Text
              fontSize={['16px', null, null, '18px']}
              color="tints.darkGrey"
              paddingInline={[0, null, null, '6']}
            >
              {card?.description}
            </Text>
          </Flex>
        </GridItem>
      ))}
    </Grid>
  </SectionContainer>
);

export default FeatureSection;
